// extracted by mini-css-extract-plugin
module.exports = {"tabListC":"tabListC_tabListC__Ghr_u"};